import { SleepingArrangements, AggregatedAccommodationType } from '../type/types';

export const getAvailabilityLabel = (item: AggregatedAccommodationType, isSoldOut = false) => {
  if (isSoldOut) return '';

  const filteredSleepingArrangements = item?.sleepingArrangements?.filter(
    (arrangement) => arrangement.physicalUnitsRemaining && arrangement.physicalUnitsRemaining > 0,
  );

  if (filteredSleepingArrangements?.length === 0) return '';

  const getAvailabilityNumber = filteredSleepingArrangements?.reduce(
    (total: number, arrangement: SleepingArrangements) => {
      if (arrangement.physicalUnitsRemaining && arrangement.physicalUnitsRemaining < 5) {
        return total + arrangement?.physicalUnitsRemaining;
      }
      return total;
    },
    0,
  );

  const hasEveryLessThan5Remaining = filteredSleepingArrangements?.every(
    (arrangement: SleepingArrangements) =>
      arrangement.physicalUnitsRemaining && arrangement.physicalUnitsRemaining < 5,
  );

  if (hasEveryLessThan5Remaining) {
    return `Only ${getAvailabilityNumber} left`;
  }

  const hasSomeLessThan5Remaining = filteredSleepingArrangements?.some(
    (arrangement: SleepingArrangements) =>
      arrangement.physicalUnitsRemaining && arrangement.physicalUnitsRemaining < 5,
  );

  if (hasSomeLessThan5Remaining) {
    return 'Limited availability';
  }

  return '';
};

export const getAvailabilityLabelAlternate = (
  item: AggregatedAccommodationType,
  isSoldOut = false,
) => {
  if (isSoldOut) return '';

  const filteredSleepingArrangements = item?.sleepingArrangements?.filter(
    (arrangement) => arrangement.physicalUnitsRemaining && arrangement.physicalUnitsRemaining > 0,
  );

  if (filteredSleepingArrangements?.length === 0) return '';

  const getAvailabilityNumber = filteredSleepingArrangements?.reduce(
    (total: number, arrangement: SleepingArrangements) => {
      if (arrangement.physicalUnitsRemaining && arrangement.physicalUnitsRemaining < 5) {
        return total + arrangement?.physicalUnitsRemaining;
      }
      return total;
    },
    0,
  );

  const hasEveryLessThan5Remaining = filteredSleepingArrangements?.every(
    (arrangement: SleepingArrangements) =>
      arrangement.physicalUnitsRemaining && arrangement.physicalUnitsRemaining < 5,
  );

  if (getAvailabilityNumber && getAvailabilityNumber < 5 && hasEveryLessThan5Remaining) {
    return `Only ${getAvailabilityNumber} left`;
  }

  return '';
};
